import { Draggable, DraggableProvided } from "@hello-pangea/dnd";
import { Add, Remove } from "@mui/icons-material";
import { Card, CardContent, CardHeader } from "@mui/material";
import { useState } from "react";
import { IListItem } from "../../interface/list-item";
import { ITreeItem } from "../../interface/tree-item";
import { StrictModeDroppable } from "./droppable";
import { BoxHeaderName } from "./enum/box-header";
import ListOptions from "./list-options";

interface ITreeOptions {
    data: Array<ITreeItem>;
    onHighlight: (isChecked: boolean, item: IListItem) => void;
    draggerInTransition?: string | null;
    rightDraggerInTransition?: string | null;
}

const TreeOptions = ({
    data,
    onHighlight,
    draggerInTransition,
    rightDraggerInTransition,
}: ITreeOptions) => {
    const [expendedList, setExpendedList] = useState<Array<string>>([]);

    const toggleHandler = (id: string) => {
        setExpendedList((currentList) => {
            if (currentList.includes(id)) {
                return currentList.filter((item) => item !== id);
            } else {
                return [...currentList, id];
            }
        });
    };

    const getStyleItem = (
        provided: DraggableProvided,
        disableTransform: boolean,
    ) =>
        disableTransform
            ? { ...provided.draggableProps.style, transform: "unset" }
            : provided.draggableProps.style;

    return (
        <>
            {data
                .filter(({ children }) => children?.length)
                .map(({ id, name, children }, index) => (
                    <Draggable
                        key={`${BoxHeaderName.PARENT}${id}`}
                        draggableId={`${BoxHeaderName.PARENT}${id}`}
                        index={index}
                    >
                        {(provided) => (
                            <Card
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className="parent-item"
                                style={getStyleItem(
                                    provided,
                                    !!rightDraggerInTransition,
                                )}
                            >
                                <CardHeader
                                    title={name}
                                    avatar={
                                        expendedList.includes(id) ||
                                        draggerInTransition === id ? (
                                            <Remove />
                                        ) : (
                                            <Add />
                                        )
                                    }
                                    value={id}
                                    onClick={() => toggleHandler(id)}
                                />
                                <StrictModeDroppable
                                    droppableId={`${BoxHeaderName.PARENT}${id}`}
                                >
                                    {(provided) => (
                                        <CardContent
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className={
                                                expendedList.includes(id) ||
                                                draggerInTransition === id
                                                    ? "list-card-content"
                                                    : "list-card-content hide"
                                            }
                                        >
                                            <ListOptions
                                                data={children ?? []}
                                                parentId={id}
                                                onHighlight={onHighlight}
                                            />
                                            {provided.placeholder}
                                        </CardContent>
                                    )}
                                </StrictModeDroppable>
                            </Card>
                        )}
                    </Draggable>
                ))}
        </>
    );
};

export default TreeOptions;
